import React from "react";

interface ProductImageProps {
  images: { src: string }[];
}

const ProductImage: React.FC<ProductImageProps> = ({ images }) => {
  return (
    <div className="flex justify-center relative flex-col py-[50px]">
      <div className="flex gap-5 max-md:flex-col justify-center">
        {images.length > 0 ? (
          <>
            <img
              src={images[0].src}
              alt="Main product"
              className="object-contain rounded-3xl h-[415px] w-[607px] max-sm:w-full max-sm:h-auto"
            />
            <div className="flex flex-col gap-4 max-sm:overflow-x-auto max-sm:flex-row">
              {images.slice(1, 4).map((img, index) => (
                <img
                  key={index}
                  src={img.src}
                  alt={`Thumbnail ${index + 1}`}
                  className="object-contain rounded-3xl border-4 border-yellow-400 border-solid h-[100px] w-[100px]"
                />
              ))}
            </div>
          </>
        ) : (
          <p>Нет изображений</p>
        )}
      </div>
    </div>
  );
};

export default ProductImage;
